export class CustomModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Let the app request a custom method.
     * @param method - Custom method name
     * @param data - Data to send
     *
     * @returns Message signed
     * @throws {@link RpcError} if an error occured on server side
     */
    request(method, data) {
        return this.client.request(method, data);
    }
}
//# sourceMappingURL=Custom.js.map